<template>
  <el-dialog title="查看" :close-on-click-modal="false" :visible.sync="visible" width="50%">
    <el-form label-position="right" class="detail_form" label-width="120px">
      <el-form-item label="基地">
        <span class="text-gray-500">{{ baseInfo.com_name || "--" }}</span>
      </el-form-item>
      <el-form-item label="预约号">
        <span class="text-gray-500">{{ detail.code || "--" }}</span>
      </el-form-item>
      <el-form-item label="门禁卡id" v-if="detail.queue.access_card_code">
        <span class="text-gray-500">{{ detail.queue.access_card_code || "--" }}</span>
      </el-form-item>
      <el-form-item label="业务类型">
        <span class="text-gray-500">{{ detail.business_name || "--" }}</span>
      </el-form-item>
      <el-form-item label="车辆业务类型">
        <span class="text-gray-500">{{
          detail.car_business_name || "--"
        }}</span>
      </el-form-item>
      <el-form-item label="车牌号">
        <span class="text-gray-500">{{
          detail.info.license_plate || "--"
        }}</span>
      </el-form-item>
      <el-form-item label="预约日期">
        <span class="text-gray-500">{{ detail.booking_day | formatDay }}</span>
      </el-form-item>
      <el-form-item label="预约时间">
        <span class="text-gray-500"
          >{{ detail.booking_time["begin_time"] }} ~
          {{ detail.booking_time["end_time"] }}</span
        >
      </el-form-item>
      <el-form-item label="登记时间">
        <span class="text-gray-500">{{ detail.report_time | formatTime }}</span>
      </el-form-item>
      <template v-if="detail.queue.access_card_state == 1">
        <el-form-item label="呼叫状态">
          <span class="text-gray-500">{{
            !detail.queue.caller_id ? "未呼叫" : "已呼叫"
          }}</span>
        </el-form-item>
        <el-form-item label="呼叫时间">
          <span class="text-gray-500">{{
            detail.queue.call_finish_time | formatTime
          }}</span>
        </el-form-item>
        <el-form-item label="呼叫人员">
          <span class="text-gray-500">{{
            detail.queue.caller_name || "--"
          }}</span>
        </el-form-item>
      </template>
      <template v-if="detail.queue.access_card_state == 2">
        <el-form-item label="发卡状态">
          <span class="text-gray-500">{{ detail.state === 46 ? '待出厂' : '待进厂' }}</span>
        </el-form-item>
        <el-form-item label="发卡时间">
          <span class="text-gray-500">{{
            detail.queue.access_card_send_time | formatTime
          }}</span>
        </el-form-item>
        <el-form-item label="发卡操作人员">
          <span class="text-gray-500">{{
            detail.queue.access_card_send_user_name || "--"
          }}</span>
        </el-form-item>
      </template>
      <el-form-item label="司机姓名">
        <span class="text-gray-500">{{ detail.info.name || "--" }}</span>
      </el-form-item>
      <el-form-item label="司机手机号">
        <span class="text-gray-500">{{ detail.info.contact || "--" }}</span>
      </el-form-item>
      <el-form-item label="身份证号">
        <span class="text-gray-500">{{ detail.info.id_card || "--" }}</span>
      </el-form-item>
      <el-form-item label="货物类型">
        <span class="text-gray-500">{{
          detail.business_goods_name || "--"
        }}</span>
      </el-form-item>
      <el-form-item label="备注">
        <span class="text-gray-500">{{ detail.note || "--" }}</span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible: false,
      detail: {
        booking_time: {},
        info: {}
      }
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  methods: {
    async onOpen(id) {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/detail_booking_card",
          data: {
            booking_id: id
          }
        });
        this.detail = dataObj.data.data;
        this.visible = true;
      } catch (error) {}
    }
  },
  filters: {
    formatDay(v) {
      return v ? moment(v, "YYYYMMDD").format("YYYY-MM-DD") : "";
    },
    formatTime(v) {
      return v ? moment.unix(v).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  }
};
</script>

<style lang="scss" scoped></style>
